import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { Router, RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { AppState } from 'src/app/ngrx/states'
import { AuthUserService } from 'src/app/service/auth/auth-user.service'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { DdcButtonROneComponent } from 'src/app/shared/ddc/ddc-button-r-one/ddc-button-r-one.component'
import { DdcButtonSOneComponent } from 'src/app/shared/ddc/ddc-button-s-one/ddc-button-s-one.component'
import { DdcTextGradientComponent } from 'src/app/shared/ddc/ddc-text-gradient/ddc-text-gradient.component'
import { MyErrorStateMatcher } from 'src/app/shared/models/matcher'
@Component({
  selector: 'ddc-find-account',
  templateUrl: './ddc-find-account.component.html',
  styleUrls: ['./ddc-find-account.component.scss'],
  imports: [
    AngularMaterialsModules,
    DdcTextGradientComponent,
    DdcButtonSOneComponent,
    DdcButtonROneComponent,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
  ],
})
export class DdcFindAccountComponent implements OnInit {
  _aCode: string
  _email: string
  _isFindAccBtnLoading = false
  _isSendResetPasswordEmailBtnLoading = false
  _submitBtnText = 'Find'
  _pageCardTitle = 'Find Account'
  _pageCardText = 'Please enter your email or username to find your account.'
  _sendResetPasswordEmailBtnText = 'Send "Reset-Password" Email'
  _hide = true
  _findAccError: string = ''
  _valid_email: string = ''
  _accountFound = false
  _resetPasswordEmailSent = false
  _minLength = 2
  _maxLength = 50

  _form = new FormGroup({
    _username_or_email: new FormControl('', [
      Validators.required,
      Validators.minLength(this._minLength),
      Validators.maxLength(this._maxLength),
    ]),
  })

  // emailFormControl = new FormControl('', [Validators.required, Validators.email])
  _matcher = new MyErrorStateMatcher()

  constructor(
    private logger: DdcLoggerService,
    private store: Store<AppState>,
    private authService: AuthUserService,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  get username_or_email(): any {
    return this._form.get('_username_or_email')
  }

  check_input_send_email(): void {
    if (!this._form.valid) {
      return null
    }

    this._isFindAccBtnLoading = true
    this._submitBtnText = 'Finding account...'

    this.authService.check_username_email_get_email(this._form.value).subscribe((res: any) => {
      if (res.message == 'Username exists' || res.message == 'Email exists') {
        this._valid_email = res.email ? res.email : this._form.value._username_or_email
        if (this._valid_email) {
          this._submitBtnText = 'Account found...'

          setTimeout(() => {
            this._accountFound = true

            this._pageCardTitle = 'Choose your option'
            this._pageCardText = 'Please click on one of the options below:'

            this._isFindAccBtnLoading = false
            this._submitBtnText = 'Find'
          }, 2000) // two seconds
        }
      } else {
        this._findAccError = 'Username/Email is not registered.'
        this._form.setErrors({
          invalidLogin: true,
        })
        this._isFindAccBtnLoading = false
        this._submitBtnText = 'Find'
      }
    })
  }

  find_acc(): void {
    this.check_input_send_email()
  }
  sss(): void {}
  sendResetPasswordEmail(): void {
    if (this._valid_email) {
      this._isSendResetPasswordEmailBtnLoading = true
      this._sendResetPasswordEmailBtnText = 'Sending email...'

      this.authService.send_reset_password(this._valid_email).subscribe((res: any) => {
        if (res.success) {
          setTimeout(() => {
            this._resetPasswordEmailSent = true
            this._accountFound = true

            this._pageCardTitle = 'Done !'
            this._pageCardText = 'Password reset email has been sent. Please check your inbox.'

            this._isSendResetPasswordEmailBtnLoading = false
            this._sendResetPasswordEmailBtnText = 'Send "Reset-Password" Email'
          }, 2000) // two seconds
        }
      })
    }
  }

  get code(): any {
    return this._form.get('_code')
  }
}
